import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["to", "label", "event", "eventLabel", "as", "onClick", "newTab", "className", "children", "aria-label", "ariaLabel"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { getOutboundLinkContainerProps } from './OutboundLink.utils';
import { Event } from '../../modules/analytics/components';
import { EventPropType } from '../../modules/analytics/types';
import { GoogleAnalytics } from '../../services/analytics';
import { ChildrenPropType } from '../../services/proptypes';
var defaultProps = {
  label: '',
  event: null,
  eventLabel: '',
  as: 'a',
  onClick: null,
  newTab: true,
  className: '',
  children: null,
  'aria-label': '',
  ariaLabel: ''
};
export default function OutboundLink(_ref) {
  var to = _ref.to,
    label = _ref.label,
    event = _ref.event,
    eventLabel = _ref.eventLabel,
    as = _ref.as,
    onClickProp = _ref.onClick,
    newTab = _ref.newTab,
    className = _ref.className,
    children = _ref.children,
    ariaLabelDom = _ref['aria-label'],
    ariaLabel = _ref.ariaLabel,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (_isEmpty(to)) {
    return null;
  }
  function createLabel() {
    var childrenLabel = typeof children === 'string' ? children : null;
    return eventLabel || label || _get(event, 'label') || childrenLabel || to;
  }
  function sendOutboundLinkEvent() {
    GoogleAnalytics.outbound(createLabel(), {
      hitCallback: function hitCallback() {
        return null;
      }
    });
  }
  function onClick(e) {
    sendOutboundLinkEvent();
    if (onClickProp) {
      onClickProp(e);
    }
  }
  var containerProps = getOutboundLinkContainerProps(_objectSpread({
    to: to,
    label: label,
    eventLabel: eventLabel,
    newTab: newTab,
    className: className,
    onClick: onClick,
    ariaLabel: ariaLabelDom || ariaLabel
  }, rest));
  var elementProps = _objectSpread(_objectSpread({}, containerProps), {}, {
    children: children || label
  });
  var Element = /*#__PURE__*/React.createElement(as, elementProps);
  if (event) {
    return /*#__PURE__*/React.createElement(Event, {
      event: event,
      eventType: "click"
    }, Element);
  }
  return Element;
}
OutboundLink.defaultProps = defaultProps;